export default __webpack_public_path__ + "static/media/ic-checkmark.2249661d.svg";